/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetSynevoReportCompanyDto
 */
export interface GetSynevoReportCompanyDto {
    /**
     * 
     * @type {string}
     * @memberof GetSynevoReportCompanyDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetSynevoReportCompanyDto
     */
    companyName: string;
    /**
     * 
     * @type {string}
     * @memberof GetSynevoReportCompanyDto
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof GetSynevoReportCompanyDto
     */
    synevoCode: string;
    /**
     * 
     * @type {string}
     * @memberof GetSynevoReportCompanyDto
     */
    supportingExaminationDictName: string;
    /**
     * 
     * @type {number}
     * @memberof GetSynevoReportCompanyDto
     */
    countSynevo: number;
}

/**
 * Check if a given object implements the GetSynevoReportCompanyDto interface.
 */
export function instanceOfGetSynevoReportCompanyDto(value: object): value is GetSynevoReportCompanyDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('synevoCode' in value) || value['synevoCode'] === undefined) return false;
    if (!('supportingExaminationDictName' in value) || value['supportingExaminationDictName'] === undefined) return false;
    if (!('countSynevo' in value) || value['countSynevo'] === undefined) return false;
    return true;
}

export function GetSynevoReportCompanyDtoFromJSON(json: any): GetSynevoReportCompanyDto {
    return GetSynevoReportCompanyDtoFromJSONTyped(json, false);
}

export function GetSynevoReportCompanyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSynevoReportCompanyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyName': json['companyName'],
        'companyId': json['companyId'],
        'synevoCode': json['synevoCode'],
        'supportingExaminationDictName': json['supportingExaminationDictName'],
        'countSynevo': json['countSynevo'],
    };
}

export function GetSynevoReportCompanyDtoToJSON(value?: GetSynevoReportCompanyDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'companyName': value['companyName'],
        'companyId': value['companyId'],
        'synevoCode': value['synevoCode'],
        'supportingExaminationDictName': value['supportingExaminationDictName'],
        'countSynevo': value['countSynevo'],
    };
}

